var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataType)?_c('div',[(_vm.dataType === 'object')?_c('pre',[_vm._v(_vm._s(_vm.newContent))]):(_vm.dataType === 'text')?_c('p',[_vm._v(_vm._s(_vm.newContent))]):(_vm.dataType === 'html')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.newContent)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }